import {
  SET_MENU_CLICKED,
  RESET_MENU_CLICKED,
  SET_LOADING,
  SET_SIDE_MENU
} from "./types";

const initialState = {
  menuClicked: null,
  sideMenu: null,
  loading: false,
};

const sidebarReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_MENU_CLICKED:
      return {
        ...state,
        menuClicked: action.payload,
      };

    case SET_SIDE_MENU:
      return {
        ...state,
        sideMenu: action.payload,
      };

    case RESET_MENU_CLICKED:
      return {
        ...state,
        menuClicked: null
      };
    case SET_LOADING:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};

export default sidebarReducer;
